import dayjs from 'dayjs';

export function formatDate(date) {
  const formattedDate =
    date == null || date == undefined
      ? null
      : dayjs(date, 'DD-MM-YYYY hh:mm:ss').format('DD-MMM-YYYY');
  return formattedDate;
}

export function getOrderedJson(jsonList, orderBy, sortBy) {
  return _.orderBy(jsonList, orderBy, sortBy)?.map((jsonObject) => jsonObject);
}

export function convertDataToTreeSelect(jsonData, parentTitle, parentVal, children) {
  const treeData = [];

  for (const obj of jsonData) {
    const node = {
      title: parentTitle ? parentTitle(obj) : obj.strLongDesc,
      value: `${parentVal ? parentVal(obj) : obj.intId}`, // Store the entire obj object as the value
      key: `${parentVal ? parentVal(obj) : obj.intId}` // Use obj ID as the unique key
    };

    // Check if there are any child nodes (nested objects within lstLuCountries)
    if (children && children(obj)) {
      // Recursively convert child nodes (assuming they exist)
      node.children = convertDataToTreeSelect(children(obj), null, null, null);
    }

    treeData.push(node);
  }

  return treeData;
}
